module.exports = __webpack_public_path__ + "img/cross-species-comparison.d9f4e671.png";